import React, { useState, useEffect, memo } from 'react';
import { Segment, Image, Dimmer, Loader } from 'semantic-ui-react';
import { Row, Col, Table, Input, Button, Space, Tooltip } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import MetViz from './MetViz';

const SubstrateTable = memo(function SubstrateTable({ url }) {

  const [state, setState] = useState({
    searchText: '',
    searchedColumn: '',
  });

  const [items, setItems] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  var searchInput;

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            // size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: text =>
      state.searchedColumn === dataIndex ? (
        <Tooltip placement="topLeft" title={
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        }>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        </Tooltip>
      ) : (
        <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = clearFilters => {
    clearFilters();
    setState({ searchText: '' });
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      ...getColumnSearchProps('Name'),
    },
    {
      title: 'PUBCHEM COMPOUND CID',
      dataIndex: 'PUBCHEM_COMPOUND_CID',
      key: 'PUBCHEM_COMPOUND_CID',
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      ...getColumnSearchProps('PUBCHEM_COMPOUND_CID'),
    },
    {
      title: 'Score',
      dataIndex: 'Score',
      key: 'Score',
      // width: 100,
      ellipsis: {
        showTitle: false,
      },
      ...getColumnSearchProps('Score'),
    },
    {
      title: 'Enzyme',
      dataIndex: 'Enzyme',
      key: 'Enzyme',
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      ...getColumnSearchProps('Enzyme'),
    },
    {
      title: 'Sequence',
      dataIndex: 'Sequence',
      key: 'Sequence',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      ...getColumnSearchProps('Sequence'),
    },
    {
      title: 'Pic',
      dataIndex: 'Pic',
      key: 'Pic',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      // ...getColumnSearchProps('SMILES'),
      render: (_, record) => {
        return (
          <Space style={{ width: "100%", textAlign: "center" }} direction='vertical'>
            <Image src={`https://d1en57qlwrlmqu.cloudfront.net/P450/20260618/img_reaction/${record.Enzyme}.png`} />
            {/* <a>{record.SMILES}</a> */}
          </Space>
        )
      }
    },
  ];


  useEffect(() => {
    if (url !== undefined) {
      readTSV(url)
    }
  }, []);

  function readTSV(props) {
    fetch(props)
      .then(res => res.text())
      .then(result => {
        setItems(processItems(result));
        setTimeout(() => {
          setIsLoaded(true);
        }, 500);
      })
  }

  function processItems(params) {
    var currentItems = [];
    let array = params.replaceAll("\r,", "").split("\n");
    for (let i = 1; i < array.length - 1; i++) {
      let currentArr = array[i].split("\t");
      let currentItem = {
        "id": currentArr[0],
        "Name": currentArr[0],
        "PUBCHEM_COMPOUND_CID": currentArr[1],
        "Score": currentArr[2],
        "Enzyme": currentArr[3],
        "Sequence": currentArr[4]
        // "SMILES": currentArr[5]
      }
      currentItems.push(currentItem);
    }
    return currentItems;
  }

  return (
    <>
    {
      isLoaded
      ?
      <div>
      <Table
        bordered
        columns={columns}
        dataSource={items}
        rowKey="Enzyme"
      />
      <Button type="primary" style={{bottom:"50px"}} onClick={()=>window.open(url)}>Export</Button>  
      </div>
      :
      <Segment>
            <Dimmer active inverted>
              <Loader size='medium'>Loading</Loader>
            </Dimmer>

            <Image src='../paragraph.png' />
          </Segment>
    }
    </>
  );
  // }
})

export default SubstrateTable;